import { useTranslation } from 'react-i18next'
import { List, ListItemButton, ListItemText, ListProps } from '@mui/material'
import { humanizeTimestamp } from '../../utils/date'
import { AxiomaW1 } from '../../types'
import { useClipboard } from '../../hooks'

export interface AxiomaW1DetailsProps extends Omit<ListProps, 'children'> {
  w1: AxiomaW1
}

export default function AxiomaW1Details({ w1, ...props }: AxiomaW1DetailsProps) {
  const { t } = useTranslation('axioma')

  const { copyToClipboard } = useClipboard()

  return (
    <List {...props}>
      {w1.asset?.name && (
        <ListItemButton>
          <ListItemText primary={w1.asset.name} secondary={t('asset:name')} />
        </ListItemButton>
      )}

      {w1.asset?.company?.name && (
        <ListItemButton>
          <ListItemText primary={w1.asset.company.name} secondary={t('asset:company')} />
        </ListItemButton>
      )}

      {w1.asset?.project?.name && (
        <ListItemButton>
          <ListItemText primary={w1.asset.project.name} secondary={t('asset:project')} />
        </ListItemButton>
      )}

      {w1.asset?.lift?.name && (
        <ListItemButton>
          <ListItemText primary={w1.asset.lift.name} secondary={t('asset:lift')} />
        </ListItemButton>
      )}

      {w1.asset?.level?.name && (
        <ListItemButton>
          <ListItemText primary={w1.asset.level.name} secondary={t('asset:level')} />
        </ListItemButton>
      )}

      <ListItemButton key="id" onClick={() => copyToClipboard(w1.id)}>
        <ListItemText primary={w1.id} secondary={t('serialNumber')} />
      </ListItemButton>

      {w1.sim_id !== null && (
        <ListItemButton key="sim_id" onClick={() => copyToClipboard(w1.sim_id!)}>
          <ListItemText primary={w1.sim_id} secondary={t('simId')} />
        </ListItemButton>
      )}

      <ListItemButton
        key="nominal_diameter"
        onClick={() => copyToClipboard(w1.nominal_diameter.toString())}
      >
        <ListItemText primary={`${w1.nominal_diameter} mm`} secondary={t('nominalDiameter')} />
      </ListItemButton>

      <ListItemButton key="created_at">
        <ListItemText primary={humanizeTimestamp(w1.created_at)} secondary={t('createdAt')} />
      </ListItemButton>
    </List>
  )
}
